module.exports = __webpack_public_path__ + "summernote.fce9a0f2784bc80eeb2f";


//////////////////
// WEBPACK FOOTER
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/assets/vendors/by_bower/summernote/dist/font/summernote.ttf?ad8d7e2d177d2473aecd9b35d16211fb
// module id = ../../../../../src/assets/vendors/by_bower/summernote/dist/font/summernote.ttf?ad8d7e2d177d2473aecd9b35d16211fb
// module chunks = styles